import { API_ENDPOINTS } from "../../../../Api/apiEndPoints";
import axiosInstance from "../../../../Api/axiosInstance"

export const getCities= async(params:Record<string,any>)=>{
    let response = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.GET_CITY_LIST,{params:params});
    return response?.data;
}


export const getALlCityAndCategory = async()=>{
    let response = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.GET_ALL_CITY_AND_CATEGORY);
    return response;
} 

type Reqbody = {
    Itownid: number;
    LocationAutoComplete_Itownid: string;
    Category: string;
    GradeId: number;
  };

  interface AddCityCategoryRequest {
    Itownid: number;
    LocationAutoComplete_Itownid: string;
    Category: string;
    GradeId: number;
  }


export const addnewCityCategory = async({Reqbody}: { Reqbody: AddCityCategoryRequest })=>{
    const url = `${API_ENDPOINTS.CONFIGURATION.POST_ADD_CITY_CATEGORY}`
    let response = await axiosInstance.post(url,Reqbody);

}

export const updateCity = async({id, Reqbody}:{id:number,Reqbody:Reqbody})=>{
    console.log('updateCity',id);
    const url  = `${API_ENDPOINTS.CONFIGURATION.UPDATE_CITY}/${id}`;
    const  response = await axiosInstance.put(url,Reqbody );
    // console.log(`ID-------------------------->${id}----------->BODY--------------->${JSON.stringify(Reqbody)}`)
    return response;
}


export const DeleteCity = async(id:number)=>{
    const url = `${API_ENDPOINTS.CONFIGURATION.DELETE_CITY}/${id}`;
    const response = await axiosInstance.delete(url);
}